<template>
    <el-card class="box-card" v-if="show">
        <div slot="header" class="clearfix">
            <span>{{'发票明细'}}</span>
        </div>
        <m-pane
            ref="tablePage"
            class="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            pageID="invoiceDetailTable"
            :currentPage="currentPage"
            @row-db-click="handleRowDBClick"
            @add-btn="addVerify(handleAdd)"
            @save-btn="handleSaves"
            @export-btn="handleExport"
            @upload-btn="handleUpload"
            @del-btn="handleDelete"
            @pageChange="handlePageChange"
            @sizeChange="handleSizeChange"
            @selectChange="handleSelectChange"
            @element-change="handleChange"
            @page-click="handlePageClick"
        ></m-pane>

        <!-- 导入 -->
        <upload-temp ref="uploadInvoiceDetail" :http-request="submitUpload" v-show="false"></upload-temp>

        <!-- 商品信息 -->
        <MyMultiSelectTableDialog
            v-if="openProductDialog"
            :tableList="productLists"
            :config="productDialogConfig"
            ref="productDialog"
            :advanceCheckedList="productCheckedList"
            @closeDialog="openProductDialog = false"
            @confirmDialog="confirmProductDialog">
        </MyMultiSelectTableDialog>
    </el-card>
</template>

<script>
import mPane from '@/modules/transport/bms/components/Table/Index.vue';
import MyMultiSelectTableDialog from '@/modules/transport/bms/components/dialog/multiSelectTableDialog/my.vue';
import UploadTemp from '../../UploadTemp.vue';
import editTableMixin from '@/modules/transport/bms/mixins/editTableMixin.js';
import invoiceMixin from '../invoiceMixin';
import {
    extsysInvoiceDtlQuery,
    saveExtsysInvoiceDtl,
    deleteExtsysInvoiceDtl,
    exportExtsysInvoiceDtl,
    importExtsysInvoiceDtl
} from '@/modules/transport/bms/api/invoiceManageApi.js';
import { queryProductInfo, queryInvoiceRegInfo } from '@/modules/transport/bms/api/invoiceRegistrationApi.js';
import baseConfig, { changeRequired, columnMap, productDialogConfig, saveDataTemp, showActionBar } from './config.js';
import { mergeMatchedKeys } from '@/modules/transport/bms/utils/common.js';
import { getDictAndOptions } from '@/modules/transport/bms/api/common.js';

export default {
    name: 'InvoiceDetailTable',
    mixins: [editTableMixin, invoiceMixin],
    components: { mPane, UploadTemp, MyMultiSelectTableDialog },
    props: {
        makeInvoiceStatus: {
            type: [String, Number]
        },
        jobId: {
            type: [String, Number]
        },
        invoiceLabel: {
            type: [String]
        },
        openInvoiceType: {
            type: [String]
        }
    },
    data() {
        return {
            columnMap,
            config: baseConfig,
            show: false,
            paneShow: true,
            openProductDialog: false,
            productDialogConfig,
            productLists: [],
            productCheckedList: [],
            allTableData: [],
            curRow: {},
            hasData: false,
            showActionBar
        };
    },
    methods: {
        // 查询发票明细执行
        queryListExecute({ params, successCallback }) {
            if (!this.jobId) return;
            this.loading = true;
            params.sourceJobId = this.jobId;
            this.openInvoiceType && (params.openInvoiceType = this.openInvoiceType); // 开票类型
            extsysInvoiceDtlQuery(params).then(res => {
                if (res && +res.code === 0) {
                    res.data.list.forEach(el => {
                        el.id = el.jobId;
                        el.amt = el.amt.toString();
                        el.taxAmt = el.taxAmt.toString();
                        el.fee = el.fee.toString();
                    });
                    this.hasData = res.data.list && !!res.data.list.length;
                    this.selected = [];
                    this.originalData = JSON.parse(JSON.stringify(res.data.list));
                    successCallback(res);
                }
            }).finally(() => {
                this.loading = false;
            });
            // 获取一份全量数据供发票预览使用
            extsysInvoiceDtlQuery({ ...params, pageNo: 1, pageSize: 9999 }).then(res => {
                if (res && +res.code === 0) {
                    this.allTableData = res.data.list;
                }
            });
        },
        addVerify(callback) {
            if (!this.isNewState(this.makeInvoiceStatus)) return;
            if (this.invoiceLabel === '20' && this.totalData.length >= 1) {
                return this.$message.warning('只能新增一条不动产经营租赁发票明细!');
            }
            callback && callback();
        },
        // 保存发票明细执行
        saveTableExecute({ params, successCallback }) {
            if (!this.isNewState(this.makeInvoiceStatus) || this.isEditHeader()) return;
            const addData = params.selected.map(item => {
                return {
                    ...item,
                    ...mergeMatchedKeys(item, saveDataTemp),
                    'sourceJobId': this.jobId
                };
            });
            this.setBtnLoading('save', true);
            saveExtsysInvoiceDtl(addData).then(res => {
                if (res && +res.code === 0) {
                    this.$emit('saveSuccess');
                    successCallback(res);
                }
            }).finally(() => {
                this.setBtnLoading('save', false);
            });
        },
        // 删除发票明细确认执行
        deleteTableConfirmExecute({ params, confirmFn, successCallback }) {
            if (!this.isNewState(this.makeInvoiceStatus)) return;
            confirmFn().then(() => {
                deleteExtsysInvoiceDtl(params.ids).then(res => {
                    if (res && +res.code === 0) {
                        successCallback();
                        this.$emit('deleteSuccess');
                    }
                });
            });
        },
        // 导出
        handleExport(row) {
            if (this.isEditHeader()) return;
            this.setBtnLoading('export', true);
            exportExtsysInvoiceDtl({
                sourceJobId: this.jobId,
                invoiceLabel: this.invoiceLabel
            }).finally(() => {
                this.setBtnLoading('export', false);
            });
        },
        // 导入
        handleUpload(row) {
            if (!['CBS', 'NOLABLE'].includes(this.invoiceLabelName)) {
                return this.$message.warning('当前发票标签不支持导入!');
            }
            if (!this.isNewState(this.makeInvoiceStatus) || this.isEditHeader()) return;
            this.$nextTick(() => {
                this.$refs.uploadInvoiceDetail.triggerUpload();
            });
        },
        submitUpload(uploadData) {
            const file = new File([uploadData.file], uploadData.file.name, {
                type: uploadData.file.type
            });
            const formData = new FormData();
            formData.append('file', file);
            formData.append('sourceJobId', this.jobId);
            formData.append('invoiceLabel', this.invoiceLabel);
            this.setBtnLoading('upload', true);
            importExtsysInvoiceDtl(formData).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('导入成功');
                    this.queryList();
                } else {
                    this.$message.warning('导入失败');
                }
            }).finally(() => { this.setBtnLoading('upload', false); });
        },
        advanceDialogShow() {
            setTimeout(() => {
                const row = this.$refs.tablePage.$refs.table.$refs.mNewTable.$refs.moduleTable.store.states.currentRow;
                this.curRow = row;
                this.openProductDialog = true;
            }, 0);
        },
        handleChange(e) {
            this.assocRequired(e);
            this.validateForm(e);
            this.autoFillVal(e);
        },
        autoFillVal(e) {
            if (e.val === '') return;
            const hasNumVal = (val) => (val === '0' || val === 0) || (!!val && (/^(-?\d+(\.\d+)?|-\.?\d+)$/).test(val));
            // 不含税金额 = 含税金额 / (1 + 税率)
            const calcFeeFn = () => hasNumVal(e.row.amt) && hasNumVal(e.row.taxRate) && (this.$set(e.row, 'fee', Number((e.row.amt / (1 + e.row.taxRate)).toFixed(2))));
            // 税额 = 含税金额 - 不含税金额
            const calcTaxRateFn = () => hasNumVal(e.row.amt) && hasNumVal(e.row.fee) && (this.$set(e.row, 'taxAmt', Number((e.row.amt - e.row.fee).toFixed(2))));
            // 含税金额 = 单价(含税) * 数量
            const calcAmt = () => hasNumVal(e.row.unitPrice) && hasNumVal(e.row.quantity) && (this.$set(e.row, 'amt', Number((e.row.unitPrice * e.row.quantity).toFixed(2))));
            // 数量 = 含税金额 / 单价(含税)
            const calcQuantity = () => hasNumVal(e.row.amt) && hasNumVal(e.row.unitPrice) && (this.$set(e.row, 'quantity', Number((e.row.amt / e.row.unitPrice).toFixed(6))));
            // 单价(含税) = 含税金额 / 数量
            const calcUnitPrice = () => hasNumVal(e.row.amt) && hasNumVal(e.row.quantity) && (this.$set(e.row, 'unitPrice', Number((e.row.amt / e.row.quantity).toFixed(6))));
            const actionFuMap = {
                'amt': () => {
                    calcFeeFn();
                    calcTaxRateFn();
                    calcQuantity();
                    calcUnitPrice();
                },
                'taxRate': () => {
                    calcFeeFn();
                    calcTaxRateFn();
                },
                'fee': () => {
                    calcTaxRateFn();
                },
                'projectName': () => {
                    calcFeeFn();
                    calcTaxRateFn();
                },
                'unitPrice': () => { // 单价
                    calcQuantity();
                    if (e.row.amt) {
                        calcAmt();
                        calcFeeFn();
                        calcTaxRateFn();
                    }
                },
                'quantity': () => { // 数量
                    calcUnitPrice();
                    if (e.row.amt) {
                        calcAmt();
                        calcFeeFn();
                        calcTaxRateFn();
                    }
                }
            };
            actionFuMap[e.prop] && actionFuMap[e.prop]();
        },
        validateForm(e) {
            const regexpMap = {
                'positiveNum': /^\d+(\.\d+)?$/, // 正数
                'num': /^(-?\d+(\.\d+)?|\.\d+)$/ // 数字(正负)
            };
            const regexpCheckFn = (regexp) => {
                if (e.val !== '' && !(regexp).test(e.val)) {
                    e.row[e.prop] = '';
                    this.$message.warning('非法字符,请重新输入！');
                }
            };
            const verifyMap = {
                'taxRate': () => {
                    regexpCheckFn(regexpMap['positiveNum']);
                    if (e.val !== '' && (e.val <= 0 || e.val >= 1)) {
                        e.row[e.prop] = '';
                        this.$message.warning('请输入值为0-1的小数！');
                    }
                },
                'quantity': () => {
                    regexpCheckFn(regexpMap['positiveNum']);
                },
                'unitPrice': () => { regexpCheckFn(regexpMap['num']); },
                'amt': () => { regexpCheckFn(regexpMap['num']); },
                'taxAmt': () => { regexpCheckFn(regexpMap['positiveNum']); },
                'fee': () => { regexpCheckFn(regexpMap['positiveNum']); }
            };
            verifyMap[e.prop] && verifyMap[e.prop]();
        },
        assocRequired({ prop, row }) {
            if (this.invoiceLabelName === 'NOLABLE') return;
            // 指定关联的字段,只要一项有值则所有关联的字段都必填
            const props = ['unitPrice', 'quantity', 'unit'];
            if (props.includes(prop)) {
                const isRequired = props.some(key => (`${row[key]}`).trim());
                changeRequired(this.config.table.columns, props, isRequired);
            }
        },
        // 获取商品信息
        getProductInfo() {
            queryInvoiceRegInfo({ 'supplierCode': '' }).then(res => {
                if (res && +res.code === 0) {
                    const jobId = res.data && res.data.length ? res.data[0].jobId : '';
                    const params = {
                        pageNo: 1,
                        pageSize: 999,
                        'sourceJobId': jobId
                    };
                    queryProductInfo(params).then(async(res) => {
                        if (res && +res.code === 0) {
                            const { SYS_BMS_BUSI_TYPE } = await getDictAndOptions('SYS_BMS_BUSI_TYPE');
                            this.productLists = res.data.list.map(el => {
                                return {
                                    id: el.jobId,
                                    businessTypeName: SYS_BMS_BUSI_TYPE[el.businessType],
                                    ...el
                                };
                            });
                        }
                    });
                }
            });
        },
        // 商品确认
        confirmProductDialog({ checkList }) {
            if (!checkList.length) {
                return this.$message.warning('请选择一条数据');
            }
            if (checkList.length !== 1) {
                return this.$message.warning('只能选择一条数据');
            }
            this.curRow.regProductId = checkList[0].jobId;
            this.curRow.projectName = `*${checkList[0].taxShortName}*${checkList[0].productName}`;
            this.curRow.taxRate = checkList[0].taxRate / 100;
            this.handleChange({ row: this.curRow, prop: 'projectName', val: this.curRow.projectName });
            this.openProductDialog = false;
        }
    },
    created() {
        this.getProductInfo();
    },
    watch: {
        show: {
            immediate: true,
            handler(newValue) {
                !this.productLists.length && this.getProductInfo();
                newValue && this.$nextTick(() => {
                    // 覆盖advanceDialog组件的show方法
                    this.$refs.tablePage.$refs.table.$refs.mNewTable.$refs.advanceDialog.show = this.advanceDialogShow;
                    this.$refs.tablePage.$refs.table.$refs.mNewTable.resetAdvanceParams = (prop, row) => {
                        row.regProductId = '';
                        row.projectName = '';
                    };
                });
            }
        },
        makeInvoiceStatus: {
            immediate: true,
            handler(newValue) {
                this.setReadOnly([10, '10'].includes(newValue));
            }
        }
    }
};
</script>

<style lang="less" scoped>
.box-card{
    margin-bottom: 20px;
}
</style>
